import { render } from "./Table.vue?vue&type=template&id=58d6e936&ts=true"
import script from "./Table.vue?vue&type=script&lang=ts"
export * from "./Table.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__